export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const GET_ACCESS = "GET_ACCESS"
export const GET_ACCESS_SUCCESS = "GET_ACCESS_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const RESET_ERROR = "RESET_ERROR"

export const FETCH_MENU = "FETCH_MENU"
export const FETCH_MENU_SUCCESS = "FETCH_MENU_SUCCESS"